export default __webpack_public_path__ + "static/media/background.75f4ae6f.jpg";